module.exports = __webpack_public_path__ + "img/vue1-corpsarr_rose.ecee6a96.png";